module.exports = __webpack_public_path__ + "static/media/promo-hotel.066a9754.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/promo-hotel.jpg
// module id = 326
// module chunks = 0